/* eslint-disable import/prefer-default-export */
import PopoverMessages from './PopoverMessages';

export const Delete = PopoverMessages.delete;
